import { EventEmitter } from 'events'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'

JobWizard.StepSequence = {
  hasCustomQuestions: false,

  defaultSequence() {
    const wizard = JobWizard
    const steps = [
      wizard.Details,
      wizard.SubCategory,
      wizard.Description,
      wizard.Schedule,
      ...loginSteps(),
      wizard.PrePostJobCheck,
      ...displayContactStep(),
      ...displayVerifyStep(),
      wizard.PostJob,
      wizard.ContactPreference,
      wizard.MoreDetails,
      wizard.Budget,
      wizard.SiteVisit,
      wizard.UpdateJob,
      wizard.JobUpgrades,
      wizard.HasJobBeenDoneYet,
      wizard.WhoDidTheJob,
      wizard.RateExperience,
      wizard.HowMuchDidYouPay,
      wizard.SubmitFeedback,
      wizard.PostJobAgain
    ]

    function loginSteps() {
      return SS.appFn.userLoggedIn() ? [] : [ wizard.EmailAddress ]
    }

    function displayContactStep() {
      return (SS.appFn.userLoggedIn() && SS.appFn.userHasPhoneForCurrentFlow())  ? [] : [ wizard.Contact ]
    }

    function displayVerifyStep() {
      return (SS.appFn.userLoggedIn() && SS.appFn.userHasVerifiedPhone()) ? [] : [ wizard.VerifyNumber ]
    }

    return steps
  },

  stepsWithProgress() {
    const wizard = JobWizard
    this.progressSteps = [
      wizard.Details.displayName,
      wizard.Description.displayName,
      wizard.Schedule.displayName,
      ...loginSteps(),
      ...displayContactStep(),
      wizard.MoreDetails.displayName,
      wizard.HasJobBeenDoneYet.displayName,
      wizard.WhoDidTheJob.displayName,
      wizard.RateExperience.displayName,
      wizard.HowMuchDidYouPay.displayName,
      wizard.SubmitFeedback.displayName,
      wizard.PostJobAgain.displayName
    ]

    function loginSteps() {
      return SS.appFn.userLoggedIn() ? [] : [ wizard.EmailAddress.displayName ]
    }

    function displayContactStep() {
      return (SS.appFn.userLoggedIn() && SS.appFn.userHasPhoneForCurrentFlow()) ? [] : [ wizard.Contact.displayName ]
    }

    return this.progressSteps
  },

  stepsForMoreDetails() {
    const wizard = JobWizard

    return [
      wizard.Budget.displayName,
      wizard.SiteVisit.displayName,
      wizard.HasJobBeenDoneYet.displayName,
      wizard.WhoDidTheJob.displayName,
      wizard.RateExperience.displayName,
      wizard.HowMuchDidYouPay.displayName,
      wizard.SubmitFeedback.displayName,
      wizard.PostJobAgain.displayName
    ]
  },

  combinedStepsWithProgress() {
    const wizard = JobWizard
    this.initialSteps = [
      wizard.Details.displayName,
      wizard.Description.displayName,
      wizard.Schedule.displayName,
      wizard.MoreDetails.displayName,
    ]

    return this.initialSteps.concat(this.stepsForMoreDetails())
  },

  insertSteps(steps, position) {
    let currentSteps = JobWizard.Steps
    JobWizard.Steps = [...currentSteps.slice(0, position), ...steps,  ...currentSteps.slice(position)]
    this.hasCustomQuestions = true
  },

  insertStepsWithProgress(steps, position) {
    let currentSteps = JobWizard.StepsWithProgress
    JobWizard.StepsWithProgress = [...currentSteps.slice(0, position), ...steps,  ...currentSteps.slice(position)]
  },

  getStepPositionByType(stepType) {
    return JobWizard.Steps.indexOf(stepType)
  },

  getStepByPosition(step) {
    return JobWizard.Steps[step]
  },

  removeStep(position) {
    let currentSteps = JobWizard.Steps
    JobWizard.Steps = [...currentSteps.slice(0, position), ...currentSteps.slice(position + 1)]
  },

  removeStepByType(stepType) {
    let position = JobWizard.Steps.indexOf(stepType)

    if (position === -1) { return }

    this.removeStep(position)
  },

  insertStepsForCategoryID(categoryID) {
    if(JobWizard.Steps.length !== JobWizard.StepSequence.defaultSequence().length) {
      //reset step sequence this handles back button and change of category
      JobWizard.Steps = JobWizard.StepSequence.defaultSequence()
      Job.Data.extraDetails = []
    }

    if(categoryHasExtraQuestions()) {
      let steps = JobWizard.Steps
      let moreStep = steps.indexOf(JobWizard.MoreDetails)
      let moreStepWithProgress = JobWizard.StepsWithProgress.indexOf(JobWizard.MoreDetails.displayName) + 1
      let subcategoryStep = steps.indexOf(JobWizard.SubCategory)
      this.removeStep(subcategoryStep) // remove subcategory slide if custom category questions are inserted
      this.insertSteps(JobWizard.CategoryBasedSteps(categoryID), moreStep)
      this.insertStepsWithProgress(JobWizard.CategoryBasedSteps(categoryID), moreStepWithProgress)
    }

    function categoryHasExtraQuestions() {
      return Job.Questions[categoryID] //see react_data/jobs/subcategory_id_questions folder for questions files
    }

  },

  init() {
    JobWizard.Emitter = JobWizard.Emitter || new EventEmitter()
    JobWizard.Emitter.removeListener('job:wizard:categorySelected', (event, selected) => {this.insertStepsForCategoryID(selected.item.id)})
    JobWizard.Emitter.addListener('job:wizard:categorySelected', (event, selected) => {this.insertStepsForCategoryID(selected.item.id)})

    JobWizard.Steps = JobWizard.StepSequence.defaultSequence()
    JobWizard.StepsWithProgress = JobWizard.StepSequence.combinedStepsWithProgress()
    this.hasCustomQuestions = false
  }
}
